import { z } from 'zod';
import { ExternalId } from '../ingest/identity.ts';

const flags = {
  isContentTest: z.boolean().optional(),
  isSeed: z.boolean().optional(),
  isEventLog: z.boolean().optional(),
};

export const CreateInternalGroupBody = z.strictObject({
  name: z.string().trim().min(1).max(80),
  description: z.string().trim().max(500).nullable().optional(),
  ...flags,
});

export const UpdateInternalGroupBody = z.strictObject({
  name: z.string().trim().min(1).max(80).optional(),
  description: z.string().trim().max(500).nullable().optional(),
  ...flags,
});

/** A member is added by external id, email (needs `pii.view`) or profile id. */
export const AddMemberBody = z.union([
  z.strictObject({ externalId: ExternalId }),
  z.strictObject({ email: z.email() }),
  z.strictObject({ profileId: z.uuid() }),
]);

export const GROUP_TYPES = ['content_test', 'seed', 'event_log'] as const;

export type CreateInternalGroupBody = z.infer<typeof CreateInternalGroupBody>;
export type UpdateInternalGroupBody = z.infer<typeof UpdateInternalGroupBody>;
export type AddMemberBody = z.infer<typeof AddMemberBody>;
